import { Component, OnInit, ViewChild, Input, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpErrorResponse, HttpHeaders, HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { FileResource, FileUploadEvent } from '../../../core/resources/file-resource';
import { ApiService, Resource } from '../../../core/services/api.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {

  @Input() public resource?: FileResource = null;

  @Input() public disabled = false;
  @Input() public hint = 'The file you wish to upload';

  @Output() public fileUploaded = new Subject<FileResource>();

  @ViewChild('file') public uploadPath;

  private defaultMessage = 'Please select a file';

  public fileName: string;
  constructor(private readonly http: HttpClient, private readonly api: ApiService) { }

  public ngOnInit() {
    this.fileName = this.resource ? this.resource.name : this.defaultMessage;
  }

  public fileSelected(evt: Event) {
    const file = this.uploadPath.nativeElement.files[0];

    const upload = this.upload(file).subscribe((data) => {
      if (data.file && this.fileUploaded) {
        this.fileUploaded.next(data.file);
        // this.file = data.file;
      }
      console.log(data);
    });
    console.log(file);
  }

  public upload(file: File) {
    return new Observable<FileUploadEvent>((observer) => {

      const url = this.api.getUrl(Resource.FILE);
      if (!url) {
        observer.error('Upload is no longer allowed for this campaign');
        return;
      }

      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${this.api.getAccessToken()}`);

      const content = new FormData();
      content.append('file', file, file.name || '');

      const req = new HttpRequest('POST', url, content, {
        headers,
        reportProgress: true,
        responseType: 'json'
      });

      this.http.request(req)
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            const percentDone = Math.round(100 * event.loaded / event.total);
            observer.next({ progress: percentDone });
          } else if (event instanceof HttpResponse) {
            const data = event.body as FileResource;
            observer.next({ file: data, progress: 100 });
            observer.complete();
          }
        }, (err: HttpErrorResponse) => {
          observer.error(err.error);
        });
    });
  }

}
